<template>
  <b-modal
    v-model="editorShown"
    title="Sign all documents"
    size="md"
    centered
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    header-class="bg-purple"
  >
    <b-form-group
      v-if="!signaturesSelected"
      label="Select the signature fields you want to include:"
    >
      <b-form-checkbox-group
        style="max-height: calc(100vh - 500px); overflow-y: auto;"
        id="checkbox-group-1"
        v-model="selected"
        :options="labels"
        stacked
      ></b-form-checkbox-group>
    </b-form-group>
    <div v-else>
      <div class="font-weight-bold" style="margin-bottom: 5px; font-size:14px;">
        Selected signatures:
      </div>
      <ul>
        <li style="margin-bottom: 5px;" v-for="item in selected" :key="item">
          <i class="fas fa-check mr-2"></i>{{ item }}
        </li>
      </ul>
      <b-link
        href="#"
        style="font-size: 14px"
        @click="signaturesSelected = false"
        >Change...</b-link
      >
      <b-form-group class="my-4" label="Sign here">
        <b-alert v-if="noSignature" show variant="danger"
          ><i class="fas fa-info-circle mr-1"></i> Please, sign below to
          continue</b-alert
        >
        <signature v-model="signature" ref="signature"> </signature>
      </b-form-group>
    </div>
    <span class="text-danger"
      ><small
        ><i class="fas fa-info-circle mr-1"></i>This operation will only apply
        to documents in PENDING or DRAFT status.</small
      >
    </span>
    <template v-slot:modal-footer>
      <button
        @click="handleDismiss"
        type="button"
        class="btn bg-med-light-gray text-white"
      >
        Close
      </button>
      <b-button v-if="signaturesSelected" @click="signAll" variant="success">
        Next
      </b-button>
      <b-button
        v-else
        @click="next"
        variant="success"
        :disabled="selected.length == 0"
      >
        Next
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import documentServer from "../../server/document";
import Signature from "../controls/Signature.vue";

export default {
  name: "SignDocumentsModal",
  components: { Signature },
  props: ["docIds"],
  data() {
    return {
      signaturesSelected: false,
      labels: [],
      selected: [],
      signature: null,
      documentsInfo: [],
      noSignature: false
    };
  },
  async mounted() {
    if (this.docIds.length > 0) {
      this.getSignatureLabels();
    }
  },
  methods: {
    signAll() {
      const result = this.$refs.signature.getSignatureValue();
      if (result) {
        this.$emit("signAll", this.documentsInfo, this.selected, result);
        this.disconectSigWeb();
      } else {
        this.noSignature = true;
      }
    },
    next() {
      this.signaturesSelected = true;
    },
    handleDismiss() {
      this.disconectSigWeb();
      this.$emit("cancel");
    },
    async getSignatureLabels() {
      this.documentsInfo = await documentServer.getDocumentsContent(
        this.docIds
      );
      this.documentsInfo.forEach(doc => {
        doc.version.content.layout.rows.forEach(row => {
          row.columns.forEach(col => {
            col.components.forEach(component => {
              if (component.elType == "Signature") {
                if (
                  !doc.results[component.id] &&
                  !this.labels.includes(component.properties.label)
                ) {
                  this.labels.push(component.properties.label);
                }
              }
            });
          });
        });
      });
    },
    setSignature(signature) {
      this.signature = signature;
    },
    disconectSigWeb() {
      if (this.$refs.signature) {
        this.$refs.signature.disconectSigWeb();
      }
    }
  },
  computed: {
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        if (!value) {
          this.disconectSigWeb();
        }
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style scoped>
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  font-size: 14px;
}
</style>
